// extracted by mini-css-extract-plugin
module.exports = {"statsBanner":"StatsBanner_statsBanner__2D471","statsItem":"StatsBanner_statsItem__2Ovbo","imgTxt":"StatsBanner_imgTxt__3SOFQ"};